import * as z from 'zod';
import { CurrencySchema } from '../enums/Currency.schema';

export const EventPricePointSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  label: z.string().min(1, 'Label is required').max(100),
  description: z.string().max(500).nullish(),
  priceCents: z.number().int().int().min(0),
  currency: CurrencySchema.default("gbp"),
  sortOrder: z.number().int(),
  availableFrom: z.coerce.date().nullish(),
  availableUntil: z.coerce.date().nullish(),
  depositCents: z.number().int().int().min(0).nullish(),
  balanceDueAt: z.coerce.date().nullish(),
  capacity: z.number().int().int().min(1).nullable().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type EventPricePointType = z.infer<typeof EventPricePointSchema>;
